export enum mliRelationshipTypesEnum {
  'Owner'= 1,
  'Partnership',
  'Exec Director',
  'Non Exec Director',
  'Trustee',
  'ShareHolder',
  'Beneficiary',
  'Signatory',
  'Card Bearer',
  'NonDisplayAccount',
  'Signatory ',
  'Card Bearer ',
  'NonDisplayAccount ',
  'None',
  'None '
}

export namespace mliRelationshipTypesEnum {
  export function values() {
    return Object.keys(mliRelationshipTypesEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}



